var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTooManyRequests = function SvgTooManyRequests(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 164,
    viewBox: "0 0 176 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9781 147.283C127.722 147.283 160.751 114.313 160.751 73.6415C160.751 32.9704 127.722 0 86.9781 0C46.2345 0 13.2053 32.9704 13.2053 73.6415C13.2053 114.313 46.2345 147.283 86.9781 147.283Z",
    fill: "#EAEAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.776 121.868L143.366 127.896L142.254 131.34L132.566 131.813C131.864 131.847 131.344 131.17 131.56 130.502L134.192 122.345C134.408 121.677 135.226 121.431 135.776 121.868Z",
    fill: "#B1B1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.262 123.402L153.215 124.674C157.243 125.969 159.456 130.278 158.158 134.298L158.009 134.761C156.711 138.782 152.395 140.991 148.367 139.696L144.414 138.425C140.386 137.129 138.173 132.82 139.47 128.8L139.62 128.337C140.917 124.317 145.234 122.107 149.262 123.402Z",
    fill: "#B1B1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.654 131.808L155.539 132.253L154.494 135.493L161.634 141.164C162.152 141.575 162.921 141.343 163.124 140.715L165.601 133.041C165.803 132.413 165.314 131.776 164.654 131.808Z",
    fill: "#B1B1D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.813 132.399L146.134 140.494L143.999 143.419L134.649 140.844C133.971 140.657 133.69 139.852 134.104 139.285L139.159 132.359C139.573 131.792 140.427 131.812 140.813 132.399Z",
    fill: "#B1B1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.142 138.065L156.499 140.507C159.919 142.994 160.671 147.778 158.179 151.191L157.892 151.585C155.401 154.998 150.608 155.75 147.188 153.262L143.831 150.821C140.412 148.334 139.659 143.55 142.151 140.136L142.438 139.743C144.929 136.329 149.722 135.578 153.142 138.065Z",
    fill: "#B1B1D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.129 150.854L156.332 148.432L154.325 151.183L159.331 158.799C159.693 159.351 160.497 159.37 160.886 158.837L165.642 152.321C166.032 151.787 165.767 151.03 165.129 150.854Z",
    fill: "#B1B1D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.75 152.584L132.334 151.094L134.119 154.242L127.906 161.677C127.456 162.216 126.605 162.139 126.258 161.529L122.03 154.071C121.684 153.46 122.056 152.692 122.75 152.584Z",
    fill: "#8B8CC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.015 143.72L136.63 141.678C140.313 139.598 144.987 140.891 147.072 144.567L147.312 144.99C149.396 148.666 148.1 153.332 144.418 155.413L140.803 157.455C137.121 159.536 132.446 158.242 130.362 154.567L130.122 154.143C128.037 150.467 129.333 145.801 133.015 143.72Z",
    fill: "#8B8CC4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.636 138.109L143.79 145.104L145.47 148.066L154.486 146.663C155.14 146.562 155.49 145.839 155.164 145.265L151.186 138.249C150.86 137.674 150.059 137.602 149.636 138.109Z",
    fill: "#8B8CC4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.076 60.8351L118.393 61.4053L116.917 58.1009L123.813 51.2923C124.313 50.7989 125.153 50.9565 125.439 51.5973L128.935 59.4241C129.221 60.065 128.777 60.7938 128.076 60.8351Z",
    fill: "#8B8CC4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.009 68.6808L113.216 70.3691C109.351 72.0891 104.822 70.3562 103.098 66.4984L102.9 66.054C101.177 62.1963 102.913 57.6747 106.778 55.9547L110.571 54.2663C114.436 52.5463 118.966 54.2793 120.689 58.137L120.887 58.5814C122.61 62.4391 120.874 66.9608 117.009 68.6808Z",
    fill: "#8B8CC4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9283 72.6812L106.416 66.2758L105.028 63.167L95.9184 63.7035C95.2583 63.7424 94.8407 64.428 95.11 65.0309L98.3988 72.3943C98.6681 72.9972 99.4581 73.1454 99.9283 72.6812Z",
    fill: "#8B8CC4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.895 60.1342L101.269 58.9388L100.419 55.4217L108.44 49.9772C109.021 49.5826 109.818 49.8898 109.983 50.5719L111.996 58.9025C112.161 59.5847 111.592 60.2208 110.895 60.1342Z",
    fill: "#8B8CC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5845 65.8415L94.5468 66.8137C90.4334 67.8041 86.2946 65.2784 85.3023 61.1724L85.188 60.6994C84.1958 56.5934 86.726 52.4619 90.8394 51.4714L94.8771 50.4992C98.9905 49.5087 103.129 52.0344 104.122 56.1405L104.236 56.6134C105.228 60.7195 102.698 64.851 98.5845 65.8415Z",
    fill: "#8B8CC4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0595 66.6782L88.6054 61.5562L87.8058 58.2473L78.7504 57.1227C78.0941 57.0412 77.5587 57.6397 77.7138 58.2814L79.6077 66.1187C79.7627 66.7604 80.5126 67.0494 81.0595 66.6782Z",
    fill: "#8B8CC4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.507 73.8174L100.431 70.4023V66.7843L109.507 63.3691C110.165 63.1217 110.868 63.6069 110.868 64.3085V72.878C110.868 73.5797 110.165 74.0649 109.507 73.8174Z",
    fill: "#8B8CC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1993 76.4845H92.0458C87.8144 76.4845 84.3843 73.0604 84.3843 68.8366V68.35C84.3843 64.1262 87.8144 60.7021 92.0458 60.7021H96.1993C100.431 60.7021 103.861 64.1262 103.861 68.35V68.8366C103.861 73.0604 100.431 76.4845 96.1993 76.4845Z",
    fill: "#8B8CC4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9666 73.1949L87.5055 69.982V66.5782L78.9666 63.3653C78.3478 63.1324 77.6868 63.5889 77.6868 64.249V72.3111C77.6868 72.9712 78.3479 73.4277 78.9666 73.1949Z",
    fill: "#8B8CC4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.726 73.4831L118.42 67.1136L119.689 63.7243L129.388 63.6953C130.091 63.6932 130.579 64.3932 130.333 65.0505L127.33 73.0783C127.084 73.7356 126.255 73.9446 125.726 73.4831Z",
    fill: "url(#paint0_radial_20980_48591)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3343 62.2328L106.46 62.2055L107.653 59.0169L100.78 53.0245C100.282 52.5903 99.5025 52.787 99.2712 53.4054L96.4452 60.9578C96.2138 61.5762 96.6731 62.2347 97.3343 62.2328Z",
    fill: "url(#paint1_radial_20980_48591)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.325 71.3332L108.434 69.8824C104.47 68.4045 102.457 63.9988 103.937 60.042L104.108 59.5862C105.588 55.6294 110.002 53.6199 113.966 55.0979L117.857 56.5486C121.821 58.0266 123.834 62.4323 122.353 66.3891L122.183 66.8449C120.702 70.8017 116.288 72.8112 112.325 71.3332Z",
    fill: "#EE8F94"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3186 53.7003L82.8672 55.8766L80.8591 52.8646L86.5198 45.002C86.93 44.4322 87.7843 44.4476 88.1737 45.0317L92.9298 52.1659C93.3192 52.75 93.0035 53.5426 92.3186 53.7003Z",
    fill: "#8B8CC4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7199 63.28L79.2621 65.5771C75.7395 67.9171 70.9835 66.9635 68.6393 63.4472L68.3693 63.0421C66.0251 59.5258 66.9803 54.7782 70.503 52.4382L73.9608 50.1411C77.4834 47.8011 82.2394 48.7547 84.5836 52.2711L84.8537 52.6761C87.1979 56.1925 86.2426 60.94 82.7199 63.28Z",
    fill: "#8B8CC4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5478 70.0715L71.8733 62.6745L69.9841 59.8408L61.0924 61.8882C60.448 62.0366 60.1509 62.7822 60.5173 63.3318L64.9918 70.0436C65.3581 70.5931 66.1619 70.6075 66.5478 70.0715Z",
    fill: "#8B8CC4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4719 75.9429L73.0767 71.0933L73.6689 67.5239L83.1822 65.635C83.8716 65.4982 84.4854 66.0915 84.3706 66.7837L82.9679 75.238C82.853 75.9303 82.0803 76.2943 81.4719 75.9429Z",
    fill: "#8B8CC4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9065 76.4034L63.8088 75.7259C59.6343 75.0358 56.8107 71.0982 57.5021 66.9312L57.5818 66.4512C58.2731 62.2841 62.2177 59.4655 66.3922 60.1557L70.4899 60.8332C74.6644 61.5233 77.488 65.4609 76.7966 69.6279L76.7169 70.108C76.0255 74.275 72.081 77.0936 67.9065 76.4034Z",
    fill: "#8B8CC4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4439 70.3469L60.3939 68.5698L60.951 65.2118L53.0529 60.6493C52.4806 60.3187 51.7536 60.6612 51.6455 61.3125L50.3258 69.2662C50.2178 69.9175 50.7953 70.4757 51.4439 70.3469Z",
    fill: "#8B8CC4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3924 70.7285L88.5842 66.674L88.8435 63.0653L98.1412 60.307C98.815 60.1071 99.4811 60.6413 99.4308 61.3412L98.8167 69.8887C98.7665 70.5885 98.0308 71.0223 97.3924 70.7285Z",
    fill: "url(#paint2_radial_20980_48591)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9748 67.9263L75.722 65.3313L75.9659 61.9363L67.6793 58.1219C67.0787 57.8454 66.3866 58.2536 66.3393 58.912L65.7616 66.9534C65.7142 67.6118 66.3409 68.1143 66.9748 67.9263Z",
    fill: "url(#paint3_radial_20980_48591)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9276 72.4383L79.7847 72.1417C75.5642 71.8395 72.3882 68.1793 72.6909 63.9663L72.7257 63.481C73.0284 59.268 76.6952 56.0977 80.9157 56.3998L85.0586 56.6964C89.2791 56.9985 92.4551 60.6588 92.1524 64.8718L92.1175 65.3571C91.8148 69.5701 88.1481 72.7404 83.9276 72.4383Z",
    fill: "#EE8F94"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.581 163.946H79.9493C55.7544 163.946 36.1406 144.367 36.1406 120.215V120.215C36.1406 96.0633 55.7544 76.4844 79.9493 76.4844H101.581C125.776 76.4844 145.389 96.0633 145.389 120.215V120.215C145.389 144.367 125.776 163.946 101.581 163.946Z",
    fill: "url(#paint4_linear_20980_48591)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.329 84.8325H54.2007V75.3527C54.2007 72.931 56.1674 70.9678 58.5934 70.9678H122.937C125.363 70.9678 127.329 72.931 127.329 75.3527V84.8325Z",
    fill: "#C3C3E1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M174.484 161.276L165.408 157.861V154.243L174.484 150.828C175.142 150.581 175.845 151.066 175.845 151.768V160.337C175.845 161.039 175.142 161.524 174.484 161.276Z",
    fill: "url(#paint5_radial_20980_48591)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.944 160.654L152.482 157.441V154.037L143.944 150.824C143.325 150.591 142.664 151.048 142.664 151.708V159.77C142.664 160.43 143.325 160.887 143.944 160.654Z",
    fill: "url(#paint6_radial_20980_48591)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M161.176 163.943H157.023C152.792 163.943 149.361 160.519 149.361 156.296V155.809C149.361 151.585 152.791 148.161 157.023 148.161H161.176C165.408 148.161 168.838 151.585 168.838 155.809V156.296C168.838 160.519 165.408 163.943 161.176 163.943Z",
    fill: "#EE8F94"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4807 160.424L36.2395 157.482L36.0518 153.869L44.9386 149.989C45.5826 149.708 46.3095 150.156 46.346 150.857L46.7906 159.415C46.827 160.116 46.1504 160.637 45.4807 160.424Z",
    fill: "#EE8F94"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3294 163.775L28.1814 163.99C23.9558 164.209 20.3525 160.967 20.1334 156.749L20.1081 156.263C19.8889 152.045 23.1368 148.448 27.3625 148.229L31.5105 148.014C35.7361 147.796 39.3394 151.038 39.5585 155.256L39.5837 155.742C39.8029 159.96 36.555 163.557 32.3294 163.775Z",
    fill: "#EE8F94"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.949 161.381L23.3096 157.731L23.133 154.332L14.439 151.565C13.8089 151.364 13.1724 151.855 13.2066 152.514L13.625 160.565C13.6593 161.224 14.3432 161.646 14.949 161.381Z",
    fill: "#EE8F94"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7065 49.8003C81.4588 49.8003 85.3114 45.9546 85.3114 41.2107C85.3114 36.4668 81.4588 32.6211 76.7065 32.6211C71.9541 32.6211 68.1016 36.4668 68.1016 41.2107C68.1016 45.9546 71.9541 49.8003 76.7065 49.8003Z",
    fill: "url(#paint7_linear_20980_48591)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M106.059 45.9933L54.5802 61.0496C50.9989 62.097 47.2451 60.0481 46.1958 56.4731C45.1464 52.8982 47.199 49.1511 50.7803 48.1036L102.26 33.0473C105.841 31.9999 109.595 34.0488 110.644 37.6238C111.693 41.1987 109.641 44.9458 106.059 45.9933Z",
    fill: "#C3C3E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20980_48591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.58 66.4566) scale(18.6193 18.5862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3646A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#E4696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#E8777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#EE8E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8F94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20980_48591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.58 66.4569) scale(20.749 20.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3646A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#E4696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#E8777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#EE8E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8F94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20980_48591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6642 67.2175) rotate(-12.4706) scale(20.0179 19.9856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3646A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#E4696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#E8777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#EE8E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8F94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20980_48591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6642 67.217) rotate(-12.4706) scale(24.3454 24.3061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3646A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#E4696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#E8777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#EE8E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20980_48591",
    x1: 103.542,
    y1: 49.3022,
    x2: 90.514,
    y2: 121.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1783,
    stopColor: "#9C9DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#B2B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#BFBFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20980_48591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.294 156.1) scale(19.005 18.9712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3646A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#E4696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#E8777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#EE8E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8F94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20980_48591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.294 156.1) scale(22.9867 22.9458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3646A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2905,
    stopColor: "#E4696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#E8777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#EE8E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20980_48591",
    x1: 78.5985,
    y1: 46.247,
    x2: 70.871,
    y2: 25.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1783,
    stopColor: "#9C9DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#B2B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    stopColor: "#BFBFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3E1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTooManyRequests);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/too_many_requests.ea7461279bcb84ebc5d01a4d91f57abf.svg";